import { HttpErrorResponse } from '@angular/common/http';
import { AuthResponse } from './../models/login.models';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from '../common/session.service';
//import { AdminService, IAdminValidationResponse } from '../common/admin.service';
import { AppConfig } from '@core_n/app.config';
import { Permission } from '@core_n/common/enums';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { userSettings } from '@core_n/common/settings';
import { AlertMsgMngrService } from '@core_n/msg/alert-msg-mngr.service';

type LoginState = 'client_credentials' | 'mfa_otp';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})


export class LoginComponent implements OnInit {
  userNameForm: FormGroup;
  mfaForm: FormGroup;
  loginState: LoginState = 'client_credentials';

  public isLoading: boolean = false;
  public title: string = "שומר נתיב";
  public ver: string = "";
  public hidePassword: boolean = true;
  private defaultErrMsg = "Cannot Access Triple C, back end server offline..."
  private username: string = '';


  constructor(private msgBoxSrv: MsgBoxService, private fb: FormBuilder, private session: SessionService, private videoMngrService: VideoMsgMngrService, private alertMngr: AlertMsgMngrService) {
    if (AppConfig.settings.PreProd)
      this.title += " PreProd";
    this.ver = `Version: ${AppConfig.version.version}  |  ${AppConfig.version.build}` ;
  }

  ngOnInit(): void {
    this.userNameForm = this.fb.group({
      username: ['', Validators.required],
      password: ['']
    });
    this.mfaForm = this.fb.group({
      code: ['', Validators.required],
    });
  }

  async onLoginClick(event: Event) {
    this.isLoading = true;
    event.preventDefault();
    let username = this.userNameForm.value.username;
    this.username = this.userNameForm.value.username;
    let password = this.userNameForm.value.password;

    // this.userNameForm.disable();
    let validationResponse: ValidationErrors = new ValidationErrors();
    // this.userNameForm.enable();
    this.userNameForm.reset();
    
    await this.videoMngrService.authenticate(username, password).subscribe({
      next: async res => {
        if (res.kind == 'success'){
          //mfa Skip
          await this.handleAuthResponse(res.authResponse);
          this.session.setLoggedIn(this.username, Permission.ADMIN);
        }
        else{
          //mfa Step
          this.isLoading = false;
          this.loginState = 'mfa_otp';
          this.videoMngrService.setMfaToken(res.details.mfa_token);
        }
      },
      error: err=> {
        this.session.setUserLoggedIn(false);
        this.userNameForm.setValue({ username: username, password: '' });
        validationResponse.incorrectLogin = true;
        this.userNameForm.setErrors(validationResponse);
        this.isLoading = false;
      } 
    });
  }

  async onMfaLoginClick(event: Event) {
    this.isLoading = true;
    event.preventDefault();
    const code = this.mfaForm.value.code;
    // this.mfaForm.disable();
    // this.mfaForm.enable();
    this.mfaForm.reset();
    
    await this.verifyMfa(code).then((res: boolean) => {
      if (res) {
        this.session.setLoggedIn(this.username, Permission.ADMIN);
        return;
      }
      else {
        this.resetLoginState()
      }
    });
  }




  async verifyMfa(code): Promise<boolean> {
    try {
      const mfaToken = this.videoMngrService.getMfaToken();
      const authResponse = await this.videoMngrService.verifyMfa(mfaToken, code).toPromise();
      await this.handleAuthResponse(authResponse);
      return true;
    } catch (error) {
      this.msgBoxSrv.showErrorMsg(error.error?.error_description ?? this.defaultErrMsg);
      console.error(error);
      return false;
    }
  }

  changeLoginState(){
    this.resetLoginState();
    this.videoMngrService.setMfaToken('');
    this.loginState = 'client_credentials'
  }

  resetLoginState(userName = ''){
    this.session.setUserLoggedIn(false);
    this.userNameForm.setValue({ username: userName, password: '' });
    this.mfaForm.setValue({ code: '' });
    let validationResponse: ValidationErrors = new ValidationErrors();
    validationResponse.incorrectLogin = true;
    this.userNameForm.setErrors(validationResponse);
    this.isLoading = false;
  }

  async handleAuthResponse(authResponse: AuthResponse){
    this.videoMngrService.setToken(authResponse.access_token);
      const perms = JSON.parse(authResponse.role);

      this.session.setUserViewPriv(perms);
      userSettings.canSeeAi = perms.canSeeAi;
      userSettings.canSeeSolo = perms.canSeeSol;
      userSettings.isCameraAdmin = perms.cameraAdmin;
      userSettings.setViewPerms();
      if (perms.uid && perms.pid)
        this.alertMngr.authenticate(perms.uid, perms.pid);
      else
        console.warn("did not get alertMngr (AWS) creds...");

      this.session.setUserLoggedIn(true, this.username, Permission.ADMIN, authResponse.access_token, this.alertMngr.getToken());
  }
  
  public togglePassword(){
    this.hidePassword = !this.hidePassword;
    console.log(this.hidePassword);
  }
}

class ValidationErrors {
  incorrectLogin: boolean;
  incorrectPassword: boolean;
  incorrectUserName: boolean;
  adminServerTimeOut: boolean;
  noAdminServer: boolean;
}  
